import React, { Component } from 'react';
import {
  
} from "react-router-dom";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from '../../constant/Utils';

import './footer.css'; 

import footerLogo from '../../images/footerLogo.png';

class Footer extends Component {

	constructor(props, context) {
	    super(props, context);
	    this.state = {
	    	
	    };
    }

	componentWillMount() {

	}


	render() {

		
		const headerArr = [
			{ name: "General\ninformation", url: "/general-information/dosage-and-administration", keyUrl: "ge" },{ name: "AE\nmanagement", url: "/special-warning", keyUrl: "ae" },
			{ name: "Slide decks", url: "/slide-decks", keyUrl: "slide-decks" },{ name: "News and updates", url: "/news-and-updates", keyUrl: "news-and-updates" }
		];

		return(
			<div className="footer">
				<div className="containerMaxWidth">
					<div className="desktopFooter">
						{
							headerArr.map((item, idx) => {
								return (
									<a href={item.url} className={(this.props.urlKey === item.keyUrl) ? "menuItem active" : "menuItem" }>
										<div>	
											<span>{item.name}</span>
										</div>
									</a>
								);
							})
						}
					</div>
					<div className="footerLogoContainer">
						<a><img className="footerLogo" src={footerLogo} /></a>
						<div className="actionBtn">
							<a href="/contact">
								<div>
									<span>CONTACT US</span>
								</div>
							</a>
						</div>
					</div>
					
				</div>
				<div className="tcBox containerMaxWidth" >
					
					<div>
					<a href="https://www.azprivacy.astrazeneca.com/asia-pacific/hongkong/en/privacy-notices.html#accordion-list-item-75b4bb02e1" target="_blank" style={{ "color": "white", "marginRight": "10px" }}><span>Astrazeneca's Privacy Notice</span></a>
                    <a href="https://www.astrazeneca.com.hk/index/legal-statement.html" target="_blank" style={{ "color": "white", "marginRight": "10px" }}><span>Legal Notice</span></a>
                    <a href="https://www.astrazeneca.com.hk/index/contact-us.html" target="_blank" style={{ "color": "white", "marginRight": "10px" }}><span>Contact us</span></a>
					<a href="https://www.daiichisankyo.com.hk/Privacy/" target="_blank" style={{ "color": "white" }}><span>Daiichisankyo's Privacy notice</span></a>
					</div>
					<div style={{  }} ><span>MED-HK-TRAS-00013 (2025/01)</span><span style={{ marginLeft: '10px' }} >HK-11371 (07/01/2025)</span></div>
					
				</div>
			</div>
		);
	}

}

const mapStateToProps = (state) => {
  return {

  };
}

const mapDispatchToProps = dispatch => bindActionCreators({

}, dispatch)

export default withRouter(connect(
  mapStateToProps,
  {  }
)(Footer));
